<div class="container-full bg-theme">
  <div class="container">
    <div class="columns">
      <div class="column is-12">
        <div
          class="temporary-item temporary-breadcrumbs"
          *ngIf="!breadcrumbLinks"
        ></div>
        <app-breadcrumbs
          [darkTheme]="true"
          [breadcrumbLinks]="breadcrumbLinks"
          *ngIf="breadcrumbLinks"
        ></app-breadcrumbs>
      </div>
    </div>
  </div>
</div>
<div class="container m-t-alt" *ngIf="post">
  <div class="columns">
    <div
      class="column is-12-mobile is-10-tablet is-offset-1-tablet is-8-desktop is-offset-2-desktop"
    >
      <div class="columns">
        <div class="column is-12">
          <span
            class="has-text-link m-b-md"
            *ngFor="let stakeholderType of post.stakeholderTypes"
            >{{ stakeholderType.name }}
          </span>
          <h1 class="title is-2 m-b-gutter m-t-md">
            {{ post.title }}
          </h1>

          <p class="title is-3" *ngIf="post.subtitle">
            {{ post.subtitle }}
          </p>
        </div>
      </div>
      <!-- Author / Working group card -->
      <div class="post-meta-author m-b-gutter flex space-between align-start">
        <div class="card card--author bg-transparent">
          <!-- Author -->
          <ng-container
            *ngIf="post && !workingGroup && (!coAuthors || !coAuthors.length)"
          >
            <a [routerLink]="['/community', post.author.slug]" class="ghost">
              <figure class="avatar m-t-0">
                <img
                  [src]="authorImage.square"
                  [alt]="post.author.name"
                  *ngIf="authorImage"
                />
                <img
                  src="./assets/images/default-author.svg"
                  [alt]="post.author.name"
                  *ngIf="!authorImage"
                />
              </figure>
            </a>
            <div class="m-l-gutter-mobile">
              <p class="m-y-0">
                <a
                  [routerLink]="['/community', post.author.slug]"
                  class="ghost is-bold small-meta"
                  >{{ post.author.name }}</a
                >
              </p>
              <p class="m-y-0">
                <span class="small-meta is-bold">
                  <a
                    [routerLink]="['/community', post.author.slug]"
                    class="ghost"
                    >{{ post.author.position
                    }}<ng-container
                      *ngIf="post.author.position && post.author.institution"
                      >, </ng-container
                    >{{ post.author.institution }}</a
                  >
                </span>
              </p>

              <p class="small-meta">
                <span class="mr-3">
                  {{ post.publicationDate | date : 'LLLL d, yyyy' }}</span
                >
                —

                <span class="m-x-xs">
                  <img
                    src="./assets/images/clock-small.svg"
                    style="position: relative; top: 3px"
                    width="16"
                    alt="clock"
                    class="m-l-xs"
                  />
                  <span class="p-x-xs">{{ minRead }} min read</span></span
                >
              </p>
            </div>
          </ng-container>

          <!-- Multiple authors (Author plus co-authors) -->
          <ng-container *ngIf="!workingGroup && coAuthors && coAuthors.length">
            <a [routerLink]="['/community', post.author.slug]" class="ghost">
              <figure class="avatar m-t-0">
                <img
                  [src]="authorImage.square"
                  [alt]="post.author.name"
                  *ngIf="authorImage"
                />
                <img
                  src="./assets/images/default-author.svg"
                  [alt]="post.author.name"
                  *ngIf="!authorImage"
                />
              </figure>
            </a>
            <a
              [routerLink]="['/community', coAuthor.slug]"
              class="ghost author-link-avatar"
              *ngFor="let coAuthor of coAuthors"
            >
              <figure class="avatar m-t-0">
                <img
                  [src]="coAuthor.image.square"
                  [alt]="coAuthor.name"
                  *ngIf="coAuthor.image"
                />
                <img
                  src="./assets/images/default-author.svg"
                  [alt]="coAuthor.name"
                  *ngIf="!coAuthor.image"
                />
              </figure>
            </a>

            <div>
              <p class="m-y-0">
                <a
                  [routerLink]="['/community', post.author.slug]"
                  class="ghost is-bold small-meta"
                  >{{ post.author.name }}</a
                >
                <a
                  [routerLink]="['/community', coAuthor.slug]"
                  class="ghost is-bold small-meta"
                  *ngFor="let coAuthor of coAuthors"
                  >, {{ coAuthor.name }}</a
                >
              </p>
              <p class="small-meta">
                <span class="m-r-xs">
                  {{ post.publicationDate | date : 'LLLL d, yyyy' }}</span
                >
                —

                <span class="m-x-xs">
                  <img
                    src="./assets/images/clock-small.svg"
                    style="position: relative; top: 3px"
                    width="16"
                    alt="clock"
                    class="m-l-xs"
                  />
                  <span class="p-x-xs">{{ minRead }} min read</span></span
                >
              </p>
            </div>
          </ng-container>

          <!-- Working group -->
          <ng-container *ngIf="workingGroup">
            <a
              [routerLink]="[
                '/network-of-experts',
                'working-group',
                workingGroup.id
              ]"
              class="ghost"
            >
              <figure class="avatar m-t-0">
                <img
                  [src]="workingGroup.image.square"
                  [alt]="workingGroup.name"
                  *ngIf="workingGroup.image"
                />
                <img
                  src="./assets/images/default-authors.svg"
                  [alt]="workingGroup.name"
                  *ngIf="!workingGroup.image"
                />
              </figure>
            </a>
            <div>
              <p class="m-y-0">
                <a
                  [routerLink]="[
                    '/network-of-experts',
                    'working-group',
                    workingGroup.id
                  ]"
                  class="ghost is-bold small-meta"
                  >{{ workingGroup.name }}</a
                >
              </p>

              <p class="small-meta">
                <span class="m-r-xs">
                  {{ post.publicationDate | date : 'LLLL d, yyyy' }}</span
                >
                —

                <span class="m-x-xs">
                  <img
                    src="./assets/images/clock-small.svg"
                    style="position: relative; top: 3px"
                    width="16"
                    alt="clock"
                    class="m-l-xs"
                  />
                  <span class="p-x-xs">{{ minRead }} min read</span></span
                >
              </p>
            </div>
          </ng-container>
        </div>
        <div class="flex align-center space-between post-meta-sharing-box">
          <div>
            <app-social-share
              [title]="post.title"
              [darkTheme]="false"
              *ngIf="post"
            ></app-social-share>
          </div>
        </div>
      </div>

      <!-- Content post start -->
      <div class="article-wrapper">
        <div
          class="flex flex-column align-start justify-start is-full-height article"
        >
          <div
            class="card has-shadow is-size-6"
            id="custom-tooltip"
            style="display: none"
          >
            <div id="custom-tooltip-html-wrapper"></div>
            <a class="tooltip__close-btn" id="close-button">
              <i class="icon icon-Closelarge"></i>
            </a>
          </div>
          <div class="full-width" [innerHTML]="postContent"></div>
        </div>

        <!-- Document list -->
        <app-document-list
          [documents]="post.documents"
          title="Related documents"
          *ngIf="post.documents.length"
        ></app-document-list>

        <hr class="m-b-md" />
        <div class="p-t-xs">
          <app-newsletter-form [withAvatar]="true"></app-newsletter-form>
        </div>
        <hr class="m-b-xl" />

        <!-- Tags -->
        <div
          class="m-t-xl m-b-xl tag-group"
          *ngIf="post.tags && post.tags.length"
        >
          <a
            class="tag m-r-xs m-b-xs has-text-danger pointer"
            *ngFor="let AIPrinciple of post.AIPrinciples"
            routerLink="/wonk/ai-principles/{{ AIPrinciple.id }}-{{
              AIPrinciple.slug
            }}"
            >{{ AIPrinciple.name }}</a
          >
          <a
            class="tag m-r-xs m-b-xs has-text-primary pointer"
            *ngFor="let policyArea of post.policyAreas"
            routerLink="/wonk/policy-areas/{{ policyArea.id }}-{{
              policyArea.slug
            }}"
            >{{ policyArea.name }}</a
          >
          <a
            class="tag m-r-xs m-b-xs has-text-link pointer"
            *ngFor="let tag of post.tags"
            routerLink="/wonk/tags/{{ tag.id }}-{{ tag.slug }}"
            >{{ tag.name }}</a
          >
          <a
            class="tag m-r-xs m-b-xs has-text-link pointer"
            *ngFor="let country of post.countries"
            routerLink="/wonk/countries/{{ country.id }}-{{ country.slug }}"
            >{{ country.name }}</a
          >
          <hr />
        </div>

        <div
          [ngClass]="{
            'flex author-card-wrapper m-t-gutter':
              !workingGroup && coAuthors && coAuthors.length
          }"
          *ngIf="!post.workingGroup"
        >
          <app-author-card
            [layout]="AuthorLayout.Regular"
            [author]="post.author"
            [authorImage]="authorImage"
            [coAuthors]="coAuthors"
          ></app-author-card>
        </div>

        <app-working-group-card
          [workingGroup]="workingGroup"
          *ngIf="workingGroup"
        ></app-working-group-card>

        <app-author-disclaimer></app-author-disclaimer>
      </div>
    </div>
  </div>
</div>
<div
  class="container-full bg-gradient"
  *ngIf="relatedPosts && relatedPosts.length"
>
  <div class="container p-y-xl">
    <div class="columns">
      <div class="column is-12">
        <h3 class="title is-3 has-tex-black">From the AI Wonk</h3>
      </div>
    </div>
    <div class="columns flex flex-wrap">
      <div
        class="column is-12-mobile is-6-tablet is-4-desktop"
        *ngFor="let relatedPost of relatedPosts"
      >
        <app-post-card [post]="relatedPost"></app-post-card>
      </div>
    </div>
  </div>
</div>
